import { useState, useRef, useEffect } from "react";
import { categories } from "@/mocks/categories";

export default function CategoryDropdown() {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  const handleSelect = (url: string) => {
    setOpen(false);
    window.open(url, "_blank", "noopener");
  };

  return (
    <div ref={ref} className="relative w-full max-w-md">
      <button
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between px-5 py-3.5 bg-white/95 backdrop-blur-sm rounded-xl border border-white/40 text-foreground-800 text-sm font-medium cursor-pointer hover:bg-white transition-colors"
      >
        <span className="flex items-center gap-2">
          <i className="ri-grid-line text-lg text-primary-500"></i>
          Browse Product Categories
        </span>
        {open ? (
          <i className="ri-arrow-up-s-line text-foreground-500"></i>
        ) : (
          <i className="ri-arrow-down-s-line text-foreground-500"></i>
        )}
      </button>

      {open && (
        <div className="absolute top-full left-0 right-0 mt-2 bg-white rounded-xl border border-background-200/80 overflow-hidden z-30 max-h-72 overflow-y-auto">
          {categories.map((cat, idx) => (
            <button
              key={idx}
              onClick={() => handleSelect(cat.url)}
              className="w-full flex items-center gap-3 px-5 py-3 text-sm text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer text-left whitespace-nowrap"
            >
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600">
                <i className={`${cat.icon} text-base`}></i>
              </span>
              {cat.name}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}